<template>
  <nav class="bg-black border-b-2 border-yellow-500 sticky top-0 z-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
      <div class="flex justify-between items-center h-16">
        <!-- Logo -->
        <router-link to="/" class="flex items-center gap-2 text-yellow-500 font-bold text-lg hover:text-yellow-400 transition-colors">
          <span class="text-2xl">🥁</span>
          <span class="hidden sm:inline">Torneo Regional</span>
        </router-link>

        <!-- Menu Links -->
        <div class="hidden md:flex items-center gap-6">
          <router-link v-if="!isAdminLoggedIn" to="/admin-login" class="text-white hover:text-yellow-400 transition-colors font-semibold">
            👨‍💼 Admin
          </router-link>
          <router-link v-else to="/admin" class="text-white hover:text-yellow-400 transition-colors font-semibold">
            👨‍💼 Panel Admin
          </router-link>
          <router-link to="/jueces" class="text-white hover:text-yellow-400 transition-colors font-semibold">
            ⚖️ Jueces
          </router-link>
          <router-link to="/public" class="text-white hover:text-yellow-400 transition-colors font-semibold">
            📺 Pantalla
          </router-link>
          <router-link to="/public/pantallas" class="text-white hover:text-yellow-400 transition-colors font-semibold bg-yellow-600 px-4 py-2 rounded-lg hover:bg-yellow-500">
            🖥️ Multi-Pantalla
          </router-link>
          <button
            v-if="isAdminLoggedIn"
            @click="cerrarSesion"
            class="text-white bg-red-600 hover:bg-red-700 transition-colors font-semibold px-4 py-2 rounded-lg"
          >
            🚪 Cerrar Sesión
          </button>
        </div>

        <!-- Mobile Menu Button -->
        <button @click="mobileMenuOpen = !mobileMenuOpen" class="md:hidden text-yellow-500 text-2xl">
          <span v-if="!mobileMenuOpen">☰</span>
          <span v-else>✕</span>
        </button>
      </div>

      <!-- Mobile Menu -->
      <div v-if="mobileMenuOpen" class="md:hidden bg-gray-900 border-t border-yellow-500 py-4 px-4 space-y-2">
        <router-link v-if="!isAdminLoggedIn" to="/admin-login" class="block text-white hover:text-yellow-400 transition-colors font-semibold py-2 px-4 rounded hover:bg-gray-800">
          👨‍💼 Admin
        </router-link>
        <router-link v-else to="/admin" class="block text-white hover:text-yellow-400 transition-colors font-semibold py-2 px-4 rounded hover:bg-gray-800">
          👨‍💼 Panel Admin
        </router-link>
        <router-link to="/jueces" class="block text-white hover:text-yellow-400 transition-colors font-semibold py-2 px-4 rounded hover:bg-gray-800">
          ⚖️ Jueces
        </router-link>
        <router-link to="/public" class="block text-white hover:text-yellow-400 transition-colors font-semibold py-2 px-4 rounded hover:bg-gray-800">
          📺 Pantalla
        </router-link>
        <router-link to="/public/pantallas" class="block text-white hover:text-yellow-400 transition-colors font-semibold py-2 px-4 rounded bg-yellow-600 hover:bg-yellow-500">
          🖥️ Multi-Pantalla
        </router-link>
        <button
          v-if="isAdminLoggedIn"
          @click="cerrarSesion"
          class="w-full text-left text-white bg-red-600 hover:bg-red-700 transition-colors font-semibold py-2 px-4 rounded"
        >
          🚪 Cerrar Sesión
        </button>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '../composables/useAuth'

const router = useRouter()
const { isAdminLoggedIn, logoutAdmin } = useAuth()

const mobileMenuOpen = ref(false)

const cerrarSesion = () => {
  logoutAdmin()
  mobileMenuOpen.value = false
  router.push('/admin-login')
}
</script>
